import { ApiError } from '@types';

export const isBackendUserNotFoundError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) return false;

  const details = (error as Partial<ApiError>).details;
  if (typeof details !== 'object' || details === null) return false;

  const nestedError = (details as { error?: unknown }).error;
  if (typeof nestedError !== 'object' || nestedError === null) return false;

  const message = (nestedError as { message?: unknown }).message;
  return typeof message === 'string' && /user account not found/i.test(message);
};
